import Vue from 'vue'
const componentsFiles = require.context(`./`, true, /.vue$/)
componentsFiles.keys().forEach(path => {
  const component = componentsFiles(path).default
  Vue.component(component.name, component)
})
